import { useState } from 'react';
import { downloadFile, getFilePreviewUrl, getFileType } from '../utils';

interface FilePreviewState {
  url: string;
  type: 'image' | 'pdf';
  filename: string;
}

export const useFileOperations = () => {
  const [filePreview, setFilePreview] = useState<FilePreviewState | null>(null);

  const openFilePreview = (filename: string, type?: 'image' | 'pdf') => {
    const fileType = type || getFileType(filename);
    const proxyUrl = getFilePreviewUrl(filename);
    
    setFilePreview({
      url: proxyUrl,
      type: fileType,
      filename,
    });
  };

  const closeFilePreview = () => {
    setFilePreview(null);
  };

  const handleDownload = async (filename: string, displayName: string) => {
    await downloadFile(filename, displayName);
  };

  return {
    filePreview,
    openFilePreview,
    closeFilePreview,
    handleDownload,
  };
}; 